import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-effb58c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "ion-align-items-center ion-justify-content-between progress-info"
}

import {computed, ComputedRef, ref, watch} from "vue";
import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonRippleEffect,
  IonImg, IonIcon,
  IonProgressBar
} from '@ionic/vue';
import useChallenge from "@/composable/useChallenge";
import {Challenge} from "@/mobipoints/challenge/challenge/challenge.type";
import router from "@/router";
import * as icons from 'ionicons/icons';
import {
  USER_CHALLENGE_STATE_CANCELLED,
  USER_CHALLENGE_STATE_NULLIFY
} from "@/mobipoints/challenge/userChallenge/user_challenge.interface";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChallengeTeaser',
  props: {
  uuid: {
    type: String,
    required: true
  },
  showProgress: {
    type: String,
    required: false,
    default: ''
  }
},
  setup(__props) {

const props = __props;

const challengeFacade = useChallenge();

const challenge = ref<Challenge>(challengeFacade.getChallenge(props.uuid) as Challenge);

const showProgressBar: ComputedRef<boolean> = computed(() => {
  return userJoinedTheChallenge.value && ('bar' === props.showProgress || 'full' === props.showProgress);
});

const showProgressInfo: ComputedRef<boolean> = computed(() => {
  return userJoinedTheChallenge.value && ('info' === props.showProgress || 'full' === props.showProgress);
});

const challengeProgress: ComputedRef<number> = computed(() => {
  let progress = 0;
  challenge.value.userChallenges.forEach((userChallenge) => {
    progress = userChallenge.progress;
  });
  return progress;
});

const challengeCancelled: ComputedRef<boolean> = computed(() => {
  return challenge.value.userChallenges.length > 0 && challenge.value.userChallenges.every((userChallenge) => {
    return USER_CHALLENGE_STATE_CANCELLED === userChallenge.state.code;
  });
});

const userJoinedTheChallenge: ComputedRef<boolean> = computed(() => {
  return challenge.value.userChallenges.length > 0 && challenge.value.userChallenges.every((userChallenge) => {
    return USER_CHALLENGE_STATE_NULLIFY !== userChallenge.state.code;
  });
});

watch(() => challengeFacade.getChallenge(props.uuid), async (newChallenge) => {
  if (props.uuid === newChallenge?.uuid) {
    challenge.value = newChallenge;
  }
});

const navigateToChallengeDetail = function (challengeUuid: string) {
  router.push({
    name: 'ChallengeDetail',
    params: {uuid: challengeUuid}
  });
}

return (_ctx: any,_cache: any) => {
  return (null !== challenge.value)
    ? (_openBlock(), _createBlock(_unref(IonCard), {
        key: 0,
        class: "ion-activatable ripple-parent challenge-card",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateToChallengeDetail(challenge.value.uuid)))
      }, {
        default: _withCtx(() => [
          (challenge.value.getImage())
            ? (_openBlock(), _createBlock(_unref(IonImg), {
                key: 0,
                class: "challenge-img",
                src: challenge.value.getImage(),
                alt: challenge.value.title
              }, null, 8, ["src", "alt"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonCardHeader), { class: "cardNewsHeader" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCardSubtitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(challenge.value.getTimesAsString(false)), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonCardTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(challenge.value.title), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (showProgressInfo.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("span", null, _toDisplayString(challengeProgress.value) + "%", 1),
                _withDirectives(_createVNode(_unref(IonIcon), {
                  icon: icons.checkmarkOutline,
                  style: {"margin-left":".25em"}
                }, null, 8, ["icon"]), [
                  [_vShow, challengeProgress.value >= 100]
                ]),
                _withDirectives(_createVNode(_unref(IonIcon), {
                  icon: icons.pauseOutline,
                  style: {"margin-left":".25em"}
                }, null, 8, ["icon"]), [
                  [_vShow, challengeCancelled.value]
                ])
              ]))
            : _createCommentVNode("", true),
          (showProgressBar.value)
            ? (_openBlock(), _createBlock(_unref(IonProgressBar), {
                key: 2,
                color: "secondary",
                value: challengeProgress.value / 100
              }, null, 8, ["value"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonRippleEffect))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})